import { ArrowNarrowLeftIcon, ChevronRightIcon } from "@heroicons/react/solid"
import ClipboardJS from "clipboard";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import iconProfile from "../images/icon-profile.svg"
import DataCenter from "../modules/DataCenter";
import { Localize, LocalStr } from "../modules/localize/Localize";
import Button from "./control/Button";
import { Icon_Copy, Icon_Lock_Closed, Icon_Setting } from "./Svgs";
import { ToastType, useToast } from "./Toast";

export const ProfileIcon = ({ onClick, className = "flex rounded-full bg-gray-200 w-8 h-8" }) => {
    return <div className={className} onClick={e => {
        if (onClick != null) onClick();
    }}>
        <img className="rounded-full" src={iconProfile}></img>
    </div>
}

export const MenuItem = ({ icon, name, toView, addView }) => {
    return <div className="w-full h-[55px] flex justify-start items-center min-h-[55px]">
        <div className="w-5 h-5 text-gray-400">
            {icon}
        </div>
        <div className="pl-2">{name}</div>
        <div className="flex flex-1 justify-end items-center"><ChevronRightIcon className="text-gray-400 w-6 h-6" /></div>
    </div>
}


export const ProfileMenu = (props) => {
    const nav = useNavigate();
    const [makeToast] = useToast();

    const copy = new ClipboardJS(".copy-address")
    copy.on('success', e => {
    })

    var referralLink = window.location + "reg/" + DataCenter.profile.referralCode;

    const getUserName = () => (DataCenter.profile.email == null || DataCenter.profile.email == "") ? DataCenter.profile.username : DataCenter.profile.email;

    return <div className="flex flex-col w-full h-full bg-white">
        <div className="flex flex-col w-full bg-white p-4">
            <div className=' w-full h-8 flex flex-col items-start justify-center' onClick={() => props.fireViewAction({ name: "close" })}>
                <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                    aria-hidden="true" />
            </div>
            <div className="flex w-full justify-start items-start">
                <ProfileIcon className="flex rounded-full bg-gray-200 w-10 h-10 mt-2" />
                <div className="flex flex-col flex-1 pl-3">
                    <div className="flex w-full text-lg font-semibold">{getUserName()}</div>
                    {/* <div className="text-gray-400 text-sm">ID: {DataCenter.accountId}</div> */}
                    <div className="flex items-center">
                        <div className="text-sm flex"><LocalStr msg={Localize.UI.ProfileMenu.referralCode} />: {DataCenter.profile.referralCode}</div>
                        <div
                            data-clipboard-text={DataCenter.profile.referralCode}
                            className="copy-address ml-1 text-gray-600"
                            type="button"
                        >
                            <Icon_Copy className="w-6 h-6" onClick={e => {
                                makeToast(Localize.getMsg(Localize.UI.ProfileMenu.codeCopied), ToastType.right)
                            }} />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <div className="text-sm ">
                            <LocalStr msg={Localize.UI.ProfileMenu.referralLink} />
                            {referralLink}
                        </div>
                        <div
                            data-clipboard-text={referralLink}
                            className="copy-address ml-1 text-gray-600"
                            type="button"
                        >
                            <Icon_Copy className="w-6 h-6" onClick={e => {
                                makeToast(Localize.getMsg(Localize.UI.ProfileMenu.linkCopied), ToastType.right)
                            }} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div className="w-full h-[1px] bg-gray-200 my-2"></div>
        {/* <div className="flex flex-col flex-1 w-full bg-white overflow-hidden">
            <div className="flex flex-1 overflow-y-scroll">
                <div className="flex flex-col w-full p-4">
                    <MenuItem icon={<Icon_Lock_Closed />} name="安全" />
                    <MenuItem icon={<Icon_Setting />} name="设置" />
                </div>
            </div>
        </div> */}
        <div className="flex w-full p-4">
            <Button widthStyle="w-full" name="L:COMMON.logout" onClicked={e => {
                DataCenter.logout();
                nav("/login");
            }} />
        </div>
    </div>
}